import React from 'react';

import TokenStorage from './hooks/TokenStorage';
import { DialogProvider } from './components/atoms/Dialog';
import AppRouter from './components/molecules/AppRouter';
import Config from './components/hoc/Config';

function App() {
    return (
        <Config>
            {
                () => (
                    <TokenStorage>
                        <DialogProvider>
                            <AppRouter />
                        </DialogProvider>
                    </TokenStorage>
                )
            }
        </Config>
    );
}

export default App;
